import { RootState } from '../rootReducer';
import { IResendByEmail, ISignUpByEmail, ISignUpForm, ISignUpState } from './signup.slices';

export const selectSignUp = (state: RootState): ISignUpState => state.signUp;
export const selectSignUpForm = (state: RootState): ISignUpForm => selectSignUp(state).form;
export const selectSignUpByEmail = (state: RootState): ISignUpByEmail => selectSignUp(state).signUpByEmail;
export const selectResendSignByEmail = (state: RootState): IResendByEmail => selectSignUp(state).resendByEmail;
